<template>
  <div>
    <section class="hero is-primary is-bold">
      <div class="hero-head">
        <nav class="navbar">
          <div class="container">
            <div class="navbar-end">
              <div class="tabs is-right">
                <span v-if="!isAuthenticated" class="navbar-item">
                  <router-link
                    :to="{ name: 'login' }"
                    class="button is-white is-outlined"
                    data-tooltip="Tooltip Text"
                  >
                    <i class="material-icons">person</i>&nbsp; Mi cuenta
                  </router-link>
                </span>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div class="hero-body">
        <div class="container has-text-centered">
          <span>
            <img width="30%" src="@/assets/logo2.png" alt="Logo" />
          </span>
          <h1
            class="title has-text-white is-4"
          >La investigación al servicio de las personas en el trabajo</h1>
          <h2
            class="subtitle has-text-white is-6"
          >CINCEL Centro de Investigación en Comportamiento Organizacional.</h2>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <span>
            <img width="100%" src="@/assets/message.png" alt="Logo" />
          </span>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <center>
          <p class="title">
            <strong>Las decisiones acertadas sólo se toman con datos confiables.</strong>
          </p>
        </center>
        <br>
        <center>
          <p class="subtitle">
            <strong>Nuestros instrumentos te brindarán datos válidos y confiables, sobre el estado actual de realidades laborales claves para la gestión positiva de las personas y la organización.</strong>
          </p>
        </center>
        <br />
        <div class="box has-background-grey-light">
          <article class="media has-background-grey-light">
            <figure class="media-left">
              <p class="image is-100x100">
                <img src="@/assets/clima1.png" alt="Clima" />
              </p>
            </figure>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div class="media-content">
              <div class="content">
                <br />
                <p class="subtitle">
                  <strong>ECO V ® - Clima Organizacional</strong>
                  <br />Lo que las personas piensan acerca del lugar donde trabajan y su labor determina en gran medida cómo se sienten y cómo se comportan. Cuando el clima es positivo se fortalece el vínculo con la organización, se disfruta más lo que se hace y se logran mejores resultados.
                </p>
              </div>
            </div>
          </article>
        </div>
        <div class="box has-background-grey-light">
          <article class="media has-background-grey-light">
            <figure class="media-left">
              <p class="image is-100x100">
                <img src="@/assets/lider.png" alt="lider" />
              </p>
            </figure>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div class="media-content">
              <div class="content">
                <br />
                <p class="subtitle">
                  <strong>Líderes PhD</strong>
                  <br />Personas que hacen la diferencia. Los líderes de los equipos siempre marcan la diferencia. El reto es lograr que ese impacto sea positivo en el bienestar, el desempeño y el desarrollo de las personas que acompañan. Nuestro instrumento permite evaluar cinco competencias que han demostrado ser condición para el éxito en desempeño de roles de liderazgo.
                </p>
              </div>
            </div>
          </article>
        </div>
        <div class="box has-background-grey-light">
          <article class="media has-background-grey-light">
            <figure class="media-left">
              <p class="image is-100x100">
                <img src="@/assets/compromiso.png" alt="compromiso" />
              </p>
            </figure>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div class="media-content">
              <div class="content">
                <br />
                <p class="subtitle">
                  <strong>Nexos – Compromiso Laboral</strong>
                  <br />Un vínculo fuerte y afectivo con el trabajo y la organización se asocia con mayor bienestar, menor rotación y mejor desempeño.
                </p>
              </div>
            </div>
          </article>
        </div>
        <div class="box has-background-grey-light">
          <article class="media has-background-grey-light">
            <figure class="media-left">
              <p class="image is-100x100">
                <img src="@/assets/felicidad.png" alt="felicidad" />
              </p>
            </figure>&nbsp;&nbsp;&nbsp;&nbsp;
            <div class="media-content">
              <div class="content">
                <br />
                <p class="subtitle">
                  <strong>F7 – Felicidad Laboral</strong>
                  <br />Se experimenta cuando se puede disfrutar el trabajo, aplicar en él las fortalezas y encontrarle sentido a lo que se hace. Tiene efectos positivos en la salud, en el compromiso, en la productividad individual y laboral.
                </p>
              </div>
            </div>
          </article>
        </div>
        <div class="box has-background-grey-light">
          <article class="media has-background-grey-light">
            <figure class="media-left">
              <p class="image is-100x100">
                <img src="@/assets/factores.png" alt="factores" />
              </p>
            </figure>&nbsp;
            <div class="media-content">
              <div class="content">
                <br />
                <p class="subtitle">
                  <strong>Factores de Riesgo Psicosocial</strong>
                  <br />Son características sociales y del entorno que tienen la capacidad de influir en la salud, bienestar, desempeño o desarrollo de las personas. Con este diagnóstico se podrán conocer los factores intralaborales, extralaborales e individuales, y sus efectos en la satisfacción laboral, el estrés y el Burnout.
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
    <y-Footer></y-Footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import yFooter from "@/components/core/Footer.vue";
export default {
  data() {
    return {
      phoneNumber: "3105349585",
      mensajeBasico: "Quiero saber sobre el plan básico de yungol",
      mensajeRecomendado: "Quiero saber sobre el plan recomendado de yungol"
    };
  },
  computed: {
    ...mapState(["isAuthenticated"])
  },
  methods: {
    registroGoogle() {
      this.$store.dispatch("notify", {
        message: "Este es un mensaje de prueba",
        type: "is-link"
      });
      this.$ga.event("landing", "prueba"); // con esto se registran eventos en google analytics
    }
  },
  components: {
    yFooter
  }
};
</script>


<style>
</style>



// WEBPACK FOOTER //
// src/components/core/Landing.vue